import React from 'react';
import { createRoot, Root } from 'react-dom/client';

import reactAngularBridge from '../../angularIntegration/reactAngularBridge';
import { $stateType } from '../../common/types/AngularTypes';

import { CreateOrgPage } from './CreateOrgPage';

interface CreateOrgPageBridgeProps {
  switchOrg: (org: { id: number }) => Promise<void>;
  returnToDashboard?: () => void;
}

const CreateOrgPageBridge = (props: CreateOrgPageBridgeProps) => {
  return <CreateOrgPage switchOrg={props.switchOrg} returnToDashboard={props.returnToDashboard} />;
};

// Wrap the component with the bridge to get ThemeProvider and other providers
const BridgedCreateOrgPage = reactAngularBridge(CreateOrgPageBridge as React.FC);

interface ControllerContext {
  $onInit: () => void;
  $onDestroy: () => void;
  root: Root | null;
  render: () => void;
}

interface AuthenticationService {
  switchOrg: (org: { id: number }) => Promise<void>;
}

interface JQLiteElement {
  [index: number]: HTMLElement;
  length: number;
}

// Angular directive factory
export function createCreateOrgPageDirective() {
  return {
    restrict: 'E',
    template: '<div id="create-org-page-root"></div>',
    controller: [
      '$element',
      '$scope',
      '$attrs',
      'Authentication',
      '$state',
      function (
        this: ControllerContext,
        $element: JQLiteElement,
        _$scope,
        _$attrs,
        Authentication: AuthenticationService,
        $state: $stateType
      ) {
        this.$onInit = () => {
          this.root = createRoot($element[0].querySelector('#create-org-page-root'));
          this.render();
        };

        this.$onDestroy = () => {
          if (this.root) {
            this.root.unmount();
            this.root = null;
          }
        };

        this.render = () => {
          this.root.render(
            <BridgedCreateOrgPage
              switchOrg={Authentication.switchOrg}
              returnToDashboard={() => {
                // Navigate using Angular state service to dashboard
                $state.go('dashboard.home');
              }}
            />
          );
        };
      },
    ],
  };
}

export default BridgedCreateOrgPage;
